import {
  IconLayoutDashboard,
  IconSettings,
  IconUsers,
  IconUserCog,
  IconBuildingSkyscraper,
  IconUserShield,
  IconAddressBook,
  IconTargetArrow,
  IconHistory, // Import history icon
} from "@tabler/icons-react";
import { ShieldCheck } from "lucide-react";
import { type SidebarData } from "@/components/layout/types";

interface RootAdminSidebarData {
  name?: string;
  email?: string;
  avatar?: string;
}

export const rootAdminSidebarData = ({
  name,
  email,
  avatar,
}: Readonly<RootAdminSidebarData>): SidebarData => ({
  user: {
    name: name ?? "Super Admin",
    email: email ?? "",
    avatar: avatar ?? "",
  },
  teams: [
    {
      name: "Ecosuite",
      logo: ShieldCheck,
      plan: "Ecosuite Super Admin",
    },
  ],
  navGroups: [
    {
      title: "General",
      items: [
        {
          title: "Dashboard",
          url: "/root-user/dashboard",
          icon: IconLayoutDashboard,
        },
        {
          title: "Organizations",
          url: "/root-user/organization",
          icon: IconBuildingSkyscraper,
        },
        {
          title: "Users",
          icon: IconUserShield,
          items: [
            {
              title: "Super Users",
              url: "/root-user/user",
              icon: IconUserCog,
            },
          ],
        },
        {
          title: "CRM",
          icon: IconUsers,
          items: [
            {
              title: "Contacts",
              url: "/root-user/customer/contacts",
              icon: IconAddressBook,
            },
            {
              title: "Leads",
              url: "/root-user/customer/leads",
              icon: IconTargetArrow,
            },
          ],
        },
        {
          title: "Audit Logs", // New Audit Log entry
          url: "/root-user/audit",
          icon: IconHistory,
        },
      ],
    },
    {
      title: "Settings",
      items: [
        {
          title: "Settings",
          url: "/root-user/settings/profile",
          icon: IconSettings,
        },
      ],
    },
  ],
});
